import React from "react";

const DATA_POINTS = [
  { day: 1, value: 45 },
  { day: 5, value: 52 },
  { day: 10, value: 38 },
  { day: 15, value: 65 },
  { day: 20, value: 48 },
  { day: 25, value: 72 },
  { day: 30, value: 58 },
];

const CHART_W = 1200;
const CHART_H = 300;
const PAD_L = 40;
const PAD_R = 20;
const PAD_T = 20;
const PAD_B = 40;
const PLOT_W = CHART_W - PAD_L - PAD_R;
const PLOT_H = CHART_H - PAD_T - PAD_B;
const MAX_Y = 80;
const Y_TICKS = [0, 20, 40, 60, 80];
const X_TICKS = [1, 5, 10, 15, 20, 25, 30];

const scaleX = (day) => PAD_L + ((day - 1) / 29) * PLOT_W;
const scaleY = (val) => PAD_T + PLOT_H - (val / MAX_Y) * PLOT_H;

const buildPath = () => {
  const pts = DATA_POINTS.map((p) => ({ x: scaleX(p.day), y: scaleY(p.value) }));
  if (pts.length < 2) return "";
  let d = `M ${pts[0].x} ${pts[0].y}`;
  for (let i = 0; i < pts.length - 1; i++) {
    const cx = (pts[i].x + pts[i + 1].x) / 2;
    d += ` C ${cx} ${pts[i].y}, ${cx} ${pts[i + 1].y}, ${pts[i + 1].x} ${pts[i + 1].y}`;
  }
  return d;
};

const AnalyticsDailyChart = () => {
  const pathD = buildPath();

  return (
    <div className="v2-analytics-pg-daily">
      <div className="v2-analytics-pg-daily__header">
        <h3 className="v2-analytics-pg-daily__title">Daily Activity</h3>
        <p className="v2-analytics-pg-daily__subtitle">
          Your activity over the last 30 days
        </p>
      </div>
      <div className="v2-analytics-pg-daily__chart-wrapper">
        <svg
          viewBox={`0 0 ${CHART_W} ${CHART_H}`}
          className="v2-analytics-pg-daily__svg"
          preserveAspectRatio="xMidYMid meet"
        >
          {/* Y-axis grid lines and labels */}
          {Y_TICKS.map((tick) => {
            const y = scaleY(tick);
            return (
              <g key={`y-${tick}`}>
                <line
                  x1={PAD_L}
                  y1={y}
                  x2={CHART_W - PAD_R}
                  y2={y}
                  stroke="#e5e7eb"
                  strokeWidth="1"
                  strokeDasharray="4 4"
                />
                <text
                  x={PAD_L - 10}
                  y={y + 4}
                  textAnchor="end"
                  fill="#9ca3af"
                  fontSize="13"
                  fontFamily="DM Sans, sans-serif"
                >
                  {tick}
                </text>
              </g>
            );
          })}

          {/* X-axis labels */}
          {X_TICKS.map((tick) => {
            const x = scaleX(tick);
            return (
              <text
                key={`x-${tick}`}
                x={x}
                y={CHART_H - 8}
                textAnchor="middle"
                fill="#9ca3af"
                fontSize="13"
                fontFamily="DM Sans, sans-serif"
              >
                {tick}
              </text>
            );
          })}

          {/* Smooth line */}
          <path d={pathD} fill="none" stroke="#eb1414" strokeWidth="2.5" />

          {/* Data dots */}
          {DATA_POINTS.map((p) => (
            <circle
              key={p.day}
              cx={scaleX(p.day)}
              cy={scaleY(p.value)}
              r="5"
              fill="#eb1414"
              stroke="#ffffff"
              strokeWidth="2"
            />
          ))}
        </svg>
      </div>
    </div>
  );
};

export default AnalyticsDailyChart;
